import { Paths } from 'shared/routes/paths';

import { Progress } from './progress';
import { Roadmap } from './roadmap';
import { Summary } from './summary';
import { Tasks } from './tasks';

export const GoalDetailRoutes = [
  {
    path: Paths.GoalDetail,
    element: <Summary />,
  },
  {
    path: Paths.GoalDetailRoadmap,
    element: <Roadmap />,
  },
  {
    path: Paths.GoalDetailProgress,
    element: <Progress />,
  },
  {
    path: Paths.GoalDetailTasks,
    element: <Tasks />,
  },
];

export const ProjectDetailRoutes = [
  {
    path: Paths.ProjectDetail,
    element: <Summary />,
  },
  {
    path: Paths.ProjectDetailRoadmap,
    element: <Roadmap />,
  },
  {
    path: Paths.ProjectDetailProgress,
    element: <Progress />,
  },
  {
    path: Paths.ProjectDetailTasks,
    element: <Tasks />,
  },
];
